// src/components/PrivateRoute.tsx
import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useSession } from '../contexts/SessionContext';

const PrivateRoute: React.FC = () => {
  const { sessionState } = useSession();
  const location = useLocation();

  // Check if the user is logged in
  return sessionState.account ? (
    <Outlet />
  ) : (
    <Navigate to="/login" state={{ from: location }} replace />
  );
};

export default PrivateRoute;
